import { Course } from '@yandex-int/k-common/typings';
// @ts-ignore
import { getIsCourseInvisibleForTeacher } from '@yandex-int/k-common/utils/get-invisible-for-teacher-courses';
import { getSpecCourse } from '@yandex-int/k-common/utils/get-spec-courses';

export const getIsCommonCourse = (course: Course, isTeacher: boolean): boolean => {
    const isNotSpecCourse = !getSpecCourse(course);
    return isNotSpecCourse && (!isTeacher || !getIsCourseInvisibleForTeacher(course));
};
